// La clave de acceso de la empresa, recordada en ESTE navegador.
//
// NO ES UN SECRETO, y por eso puede vivir aquí: va impresa en la hoja
// que se le entrega al empleado y su único trabajo es DESAMBIGUAR —
// `jlopez` puede existir en cien empresas y hay que saber en cuál se
// está entrando. Lo que protege la cuenta es la contraseña.
//
// Guardarla es lo que convierte «empresa, usuario y contraseña» en
// «usuario y contraseña» a partir de la segunda vez, que es la
// diferencia entre una pantalla cómoda y una que hay que teclear entera
// a las seis de la mañana con guantes puestos.
//
// VIVE EN SU PROPIO ARCHIVO y no junto al contexto de sesión porque el
// lint lo pide con razón: un archivo que exporta componentes no debe
// exportar además funciones sueltas, o el recargado en caliente deja de
// funcionar en toda la aplicación.
const CLAVE = 'tego.empresa';

// TODO ENVUELTO EN try/catch. Una ventana privada, un navegador con el
// almacenamiento bloqueado o una política de empresa hacen que estas
// llamadas LANCEN, no que devuelvan vacío. Sin la red, la pantalla de
// acceso se caería entera por no poder recordar un dato que es una
// comodidad.
export function claveEmpresaRecordada() {
  try {
    return localStorage.getItem(CLAVE) || '';
  } catch {
    return '';
  }
}

export function recordarClaveEmpresa(valor) {
  try {
    localStorage.setItem(CLAVE, valor);
  } catch {
    /* Sin almacenamiento solo pasa una cosa: la tendrá que teclear cada
       vez. No es motivo para que el acceso falle. */
  }
}
